import React from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import steqyema from "../assets/img/steqeyma.png";
import zymfentra from "../assets/img/Zymfentra_Logo_SC120mg.png";
import osenvelt from "../assets/img/osenvelt-logo.png";
import stoboclo from "../assets/img/stoboclo-logo.png";
import avtozma from "../assets/img/avtozma-logo.png";
import omlyclo from "../assets/img/omlyclo-logo.png";

const Header = () => {
  const location = useLocation();

  const getLineLayer = () => {
    if (location.pathname.includes("steqeyma"))
      return "line-layer-steqeyma-desktop";
 if (location.pathname.includes("osenvelt"))
      return "line-layer-osenvelt-desktop";
 if (location.pathname.includes("stoboclo"))
      return "line-layer-stoboclo-desktop";        
    if (location.pathname.includes("zymfentra"))
      return "line-layer-zymfentra-desktop";
    if (location.pathname.includes("avtozma"))
      return "line-layer-avtozma-desktop";    
    if (location.pathname.includes("omlyclo"))
      return "line-layer-omlyclo-desktop";
    return "line-layer-desktop";
  };

  const isPaysign =
    location.pathname === "/entry/osenvelt" ||
    location.pathname === "/entry/stoboclo" ||  
    location.pathname === "/entry/steqeyma" ||
    location.pathname === "/entry/avtozma" ||
    location.pathname === "/entry/omlyclo" ||
    location.pathname === "/" ||
    location.pathname === "/inquiry-form/steqeyma" ||
    location.pathname === "/inquiry-form/osenvelt" ||
    location.pathname === "/inquiry-form/stoboclo" ||
    location.pathname === "/inquiry-form/avtozma" ||
    location.pathname === "/inquiry-form/omlyclo" ||
    location.pathname.includes("zymfentra");

  return (
    <header className={isPaysign ? "header2" : "header"}>
      <Container fluid>
        <div className="header-content">
          <div className="logo2">
            <Link to="/">
              <img src={Logo} alt="logo" className={location.pathname.includes("adalimumab") || location.pathname.includes("vegzelma") ? "celltrion-cares-logo-entry" : "celltrion-cares-logo"} />
            </Link>
            {location.pathname.includes("osenvelt") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/osenvelt">
                  <img
                    className="osenvelt-logo"
                    src={osenvelt}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}
            {location.pathname.includes("stoboclo") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/stoboclo">
                  <img
                    className="stoboclo-logo"
                    src={stoboclo}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}    
            {location.pathname.includes("avtozma") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/avtozma">
                  <img
                    className="stoboclo-logo"
                    src={avtozma}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}                     
            {location.pathname.includes("omlyclo") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/omlyclo">
                  <img
                    className="steqeyma-logo"
                    src={omlyclo}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}
            {location.pathname.includes("steqeyma") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/steqeyma">
                  <img
                    className="steqeyma-logo"
                    src={steqyema}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}

            {location.pathname.includes("zymfentra") && (
              <>
                <div className="horizontal-line" />
                <Link to="/entry/zymfentra">
                  <img
                    className="steqeyma-logo"
                    src={zymfentra}
                    alt="line-layer"
                  />
                </Link>
              </>
            )}
          </div>
          {isPaysign && (
            <>
              {/* Desktop Button (inside header-content) */}
              <div className="header-button desktop-only">
                <a
                  href="https://celltrionconnect.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-button theme-btn"
                >
                  Visit Celltrion CONNECT<sup className="reg">&reg;</sup>
                </a>
              </div>
            </>
          )}
        </div>
      </Container>
      {isPaysign && (
        <>
          <div className={getLineLayer()} />

          {/* Mobile Button (below line layer) */}
          <div className="header-button mobile-only">
            <a
              href="https://celltrionconnect.com"
              target="_blank"
              rel="noopener noreferrer"
              className="header-button theme-btn"
            >
              Visit Celltrion CONNECT<sup className="reg">&reg;</sup>
            </a>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
